import React from 'react';
import ScrollService from '../../../../utils/ScrollService';
import Typical from 'react-typical';
import './Profile.css';

export default function Profile ()
{

  return (
    <div className="profile-container">
      <div className='profile-parent'>
        <div className='profile-details'>
          <div className='colz'>
            <div className='colz-icon'>

              <a href='https://www.linkedin.com/in/ymw0331/' target="_blank" rel="noreferrer">
                <i className='fa fa-linkedin-square'></i>
              </a>
              <a href='https://github.com/ymw0331' target="_blank" rel="noreferrer">
                <i className='fa fa-github'></i>
              </a>
              <a href='https://wa.link/kz6sgq' target="_blank" rel="noreferrer">
                <i className='fa fa-whatsapp'></i>
              </a>

            </div>
          </div>
          <div className='profile-details-name'>
            <span className='primary-text'>
              { "" }
              Hello, I'm <span className='highlighted-text'>Ming Wei</span>
            </span>
          </div>
          <div className='profile-details-role'>
            <span className='primary-text'>
              { "" }
              <h1>
                { "" }
                <Typical
                  loop={ Infinity }
                  steps={ [
                    "Enthusiastic Dev 😎", 2000,
                    "Full stack Developer 💻", 2000,
                    "Mern stack Dev 📱", 2000,
                    "AWS Cloud Practitioner ☁️", 2000,
                    "React/React Native 🌐", 2000,
                  ] }
                />
              </h1>
              <span className='profile-role-tagline'>
                Knack of building application with front and back end operations
              </span>
            </span>
          </div>
          {/* Change this to my own resume */ }
          <div className='profile-options'>
            <button className="btn primary-btn"

              onClick={ () => ScrollService.scrollHandler.scrollToHireMe() }
            > Hire Me </button>

            <a href='resume_yong_ming_wei.pdf.pdf' download='resume_yong_ming_wei.pdf'>
              <button className='btn highlighted-btn'>
                Get Resume</button>
            </a>

          </div>
        </div>
        <div className='profile-picture'>
          <div className='profile-picture-background'>

          </div>
        </div>
      </div>
    </div>
  );
}
